import {SET_PROVIDER, Web3ActionTypes} from '../../types/actions/Web3.actions';
import { BrowserProvider } from 'ethers';

export interface Web3State {
  provider: BrowserProvider | null;
}

const initialState: Web3State = {
  provider: null,
};

export default (state = initialState, action: Web3ActionTypes): Web3State => {
  switch (action.type) {
    case SET_PROVIDER:
      return {...state, provider: action.payload.provider};

    default:
      return state;
  }
};
